{
    "cart": {
        "title": "{count} items in cart",
        "titleEmpty": "Shopping Cart",
        "close": "Close cart",
        "loading": "Loading …",
        "orderSummary": "Order summary",
        "total": "Total",
        "subtotal": "Subtotal",
        "tax": "Incl. tax",
        "shipping": "Shipping",
        "discount": "Discount",
        "empty": "Nothing packed yet.",
        "emptyShopCta": "Browse now",
        "checkout": "Checkout",
        "buttonLabel": "Shopping cart, {count} items",
        "removeItem": "Remove",
        "increment": "Increase quantity",
        "decrement": "Decrease quantity",
        "quantity": "Quantity",
        "couponCode": "Coupon code",
        "applyCoupon": "Apply",
        "removeCoupon": "Remove coupon",
        "errors": {
            "loadFailed": "Failed to load cart",
            "addFailed": "Failed to add to cart",
            "updateFailed": "Failed to update cart",
            "removeFailed": "Failed to remove item",
            "couponFailed": "Failed to apply coupon code"
        }
    },
    "addToCart": {
        "default": "Add to Cart",
        "inCart": "In Cart ({qty})",
        "selectLabel": "Select variant",
        "outOfStock": "Out of stock"
    },
    "checkout": {
        "shoppingCart": "Shopping Cart",
        "details": {
            "fields": {
                "fullName": "Full name",
                "organization": "Organisation / Company",
                "addressLine1": "Address line 1",
                "addressLine2": "Address line 2",
                "countryCode": "Country",
                "countryCodePlaceholder": "Select country",
                "postalCode": "Postal code",
                "locality": "City"
            }
        }
    }
}
